(function () {
  function init(root) {
    var btn = root.querySelector('[data-description-toggle]');
    var preview = root.querySelector('[data-description-preview]');
    var full = root.querySelector('[data-description-full]');
    if (!btn || !preview || !full) return;

    var readMore = btn.dataset.readMore || '';
    var readLess = btn.dataset.readLess || '';

    btn.addEventListener('click', function () {
      var expanded = btn.getAttribute('aria-expanded') === 'true';
      expanded = !expanded;
      btn.setAttribute('aria-expanded', expanded);
      btn.textContent = expanded ? readLess : readMore;
      preview.hidden = expanded;
      full.hidden = !expanded;
    });
  }

  function ready() {
    document.querySelectorAll('[data-product-description-collapsible]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ready);
  } else {
    ready();
  }

  document.addEventListener('shopify:section:load', function (ev) {
    if (!ev.target || !ev.target.querySelectorAll) return;
    ev.target.querySelectorAll('[data-product-description-collapsible]').forEach(init);
  });
})();
